import { fg } from '@atlaskit/platform-feature-flags';

import { PrimaryProductKeys } from '../constants/primary-product-keys';
import type { PrimaryProductKey } from '../constants/product-keys';

import { serveFpsMultiSiteSearchExperiment } from './experiments';

/**
 * Builds the AGG site ARI used as the `cloudIdARI` variable / `locations` value for
 * single-site search-page GraphQL queries.
 */
export const getCloudIdARI = (
	cloudId: string,
	primaryProduct: PrimaryProductKey | undefined,
): string => {
	if (serveFpsMultiSiteSearchExperiment({ primaryProduct, fireExperimentExposure: false })) {
		// TODO: Add a check here if unitMetadata > 1 it should use platform
		return `ari:cloud:platform::site/${cloudId}`;
	}

	return primaryProduct === PrimaryProductKeys.Jira && fg('jira_site_ari_query_enabled')
		? `ari:cloud:jira::site/${cloudId}`
		: `ari:cloud:confluence::site/${cloudId}`;
};

/**
 * Builds the array of AGG site ARIs used as the `cloudIdARIs` variable / `locations` value for
 * search-page GraphQL queries.
 */
export const getCloudIdARIs = (
	cloudId: string,
	primaryProduct: PrimaryProductKey | undefined,
	additionalCloudIds: readonly string[] = [],
): string[] =>
	[
		cloudId, // The current/primary site is always first
		...additionalCloudIds, // For multi-site search queries
	]
		.filter((id, index, all) => Boolean(id) && all.indexOf(id) === index) // Dedupe any duplicate cloudIds
		.map((id) => getCloudIdARI(id, primaryProduct));
